import React, { Autocomplete, Grid, Paper, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { StatisticsService } from 'services';
import { BarChart, PieChart } from '@mui/x-charts';
import { useQuery } from '@tanstack/react-query';

export const MonthReporting = () => {
	const months = Array.from(Array(12).keys()).map(month => ({ number: month + 1, name: new Date(0, month).toLocaleString('default', { month: 'long' }) }));
	const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
	const { data, isFetching, error } = useQuery({ queryKey: ['monthly-statistics', selectedMonth], queryFn: async () => await StatisticsService.getMonthlyStatistics(selectedMonth) });
	return (
		<>
			{isFetching && <Typography variant='h3'>Loading data...</Typography>}
			{error && <Typography variant='h3'>Error has occured! Please refresh the page.</Typography>}
			<Grid container component={Paper} p={1}>
				<Grid item xs={12} pb={3}>
					{months && months.length > 0 && (
						<>
							<Autocomplete
								options={months}
								getOptionLabel={option => option.name}
								value={months.find(month => month.number === selectedMonth) ?? null}
								onChange={(_, value) => setSelectedMonth(value?.number || 0)}
								renderInput={params => <TextField {...params} label='Month' size='small' />}
							/>
						</>
					)}
				</Grid>
				{data && (
					<>
						<Grid item xs={12}>
							{data.products && data.products.length > 0 && data.sales && data.sales.length > 0 && (
								<BarChart series={[{ data: data.sales }]} height={400} xAxis={[{ data: [...data.products], scaleType: 'band' }]} />
							)}
						</Grid>
						<Grid item xs={6}>
							<Typography variant='h6'>BP Points: {data.bpPoints + data.leftBPPoints + data.rightBPPoints} </Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography variant='h6'>PP Points: {data.ppPoints}</Typography>
						</Grid>
						<Grid item xs={12}>
							<Grid container padding={2}>
								<PieChart
									series={[
										{
											data: [
												{ id: 0, value: data.leftBPPoints, label: 'Left BP Points' },
												{ id: 1, value: data.rightBPPoints, label: 'Right BP Points' },
											],
										},
									]}
									height={200}
								/>
							</Grid>
						</Grid>
					</>
				)}
			</Grid>
		</>
	);
};